import * as React from 'react';
import { Label } from '@cian/ui-kit';

import { LABEL_BACKGROUNDS, LABEL_COLORS, LABEL_ICONS_MAP } from './constants';
import * as styles from './PromoItemLabel.css';
import { SEO_LABEL_TYPES, SEO_ACTION_TEXT } from '../../../../constants/seo';
import { useNewbuildingListingUrl } from '../../../../hooks';
import { ELabelType } from '../../../../types/promosPage';

interface IPromoItemLabelProps {
  newbuildingIds: number[];
  text: string;
  type: ELabelType;
}

export const PromoItemLabel: React.FC<IPromoItemLabelProps> = React.memo(({ newbuildingIds, text, type }) => {
  const href = useNewbuildingListingUrl(newbuildingIds);

  if (SEO_LABEL_TYPES.includes(type)) {
    return (
      <a href={href} onClick={event => event.stopPropagation()}>
        <span className={styles['seo-text']}>{SEO_ACTION_TEXT}</span>
        <div
          className={styles['fake-label']}
          style={{
            backgroundColor: `var(--${LABEL_BACKGROUNDS[type]})`,
            color: `var(--${LABEL_COLORS[type]})`,
          }}
        >
          <img src={LABEL_ICONS_MAP[type]} alt={SEO_ACTION_TEXT} />
        </div>
      </a>
    );
  }

  return (
    <Label background={LABEL_BACKGROUNDS[type]} color={LABEL_COLORS[type]}>
      {text}
    </Label>
  );
});

PromoItemLabel.displayName = 'PromoItemLabel';
